import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
  CardSubtitle,
  Alert,
} from "reactstrap"

import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvRadioGroup,
  AvRadio,
  AvCheckbox,
} from "availity-reactstrap-validation"

import Dropzone from "react-dropzone"

import classnames from "classnames"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// Environmental service
import EnvironmentalAudit from "services/EnvironmentalAudit.service"

// Image Viewer
import ViewFiles from "components/Services/environment/en/ViewFiles"

import DecisionInfo from "components/Services/environment/en/DecisionInfo"
import General from "services/GeneralEndpoints"
import DocumentUpload from "components/Services/Common/DocumentUpload"
import ApplicantDetails from "components/ApplicantDetails/ApplicantDetails"
import InstitutionDetails from "pages/Common/InstitutionDetails"
import EnvironmentalAuditPreview from "components/Preview/EnvironmentalAuditPreview"
import ProjectLocation from "./ProjectLocation"
import EnvironmentalAuditAttachments from "./Attachments"
import AuditPhaseTwo from "./AuditPhaseTwo"
import ConditionsOfApproval from "./ApprovalConditions"
import { EIA_Attachments, Other_Env_Audit_Attachments } from "./Attachments"
import MultiProjectLocations from "./MultiProjectLocations"

const STATIC_FILES = process.env.REACT_APP_STATIC_FILES
const BASE_URL = process.env.REACT_APP_BASE_URL

const user = JSON.parse(localStorage.getItem("authUser"))
const environmentalAuditService = new EnvironmentalAudit(user)

let generalService = new General(user)

const EnvironmentalAuditApply = props => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  const [progressValue, setprogressValue] = useState(25)
  const [activeTabVartical, setoggleTabVertical] = useState(1)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [productTypes, setproductTypes] = useState([])
  const [isReturned, setisReturned] = useState(false)

  const [selectedFiles, setselectedFiles] = useState([])
  const [uploadedImages, setUploadedImages] = useState([])
  const [alreadySubmitted, setalreadySubmitted] = useState(false)
  const [uploadedFiles, setuploadedFiles] = useState([])

  const envAuditFormRef = useRef(null)

  // form attributes
  const [applicationId, setapplicationId] = useState()
  const [loading, setloading] = useState(false)
  const [submitted, setsubmitted] = useState(false)
  const [error, seterror] = useState()
  const [applicationDetails, setApplicationDetails] = useState({})

  // submitted Application Details
  const [submittedApplication, setsubmittedApplication] = useState()
  const [subimttedFormData, setsubmittedFormData] = useState({})
  const [disableFormFields, setdisableFormFields] = useState(false)
  const [currentPath, setcurrentPath] = useState(
    window.location.pathname + props.location.search
  )
  const [showDecisionInfo, setshowDecisionInfo] = useState(false)
  const [decisionInfo, setDecisionInfo] = useState({})
  const [companies, setcompanies] = useState()
  const [companyId, setcompanyId] = useState()
  const [measures, setmeasures] = useState()
  const [measureId, setmeasureId] = useState("")
  const [legalStatusType, setlegalStatusType] = useState()

  const [productTypesRaw, setproductTypesRaw] = useState([])
  const [serviceAttachments, setserviceAttachments] = useState([])
  const [measuresRaw, setmeasuresRaw] = useState()
  const [editMode, seteditMode] = useState(false)

  const attachmentsFormRef = useRef(null)

  const [isFreshApplication, setisFreshApplication] = useState(true)
  const [showDocuments, setshowDocuments] = useState(false)
  const [renderOtherItems, setrenderOtherItems] = useState(false)
  const [cancelUpload, setcancelUpload] = useState(false)

  const [showPhaseTwo, setshowPhaseTwo] = useState(false)
  const [showDeveloperFormModal, setshowDeveloperFormModal] = useState(false)

  const [showDeveloperDetails, setshowDeveloperDetails] = useState(false)

  const [finalTOR, setfinalTOR] = useState({})
  const [projectLocationNames, setProjectLocationNames] = useState({
    sector: "",
    cell: "",
    village: "",
    district: "",
    province: "",
  })

  const [showOtherSectorOfActivity, setshowOtherSectorOfActivity] =
    useState(false)

  const [showApprovalConditions, setshowApprovalConditions] = useState(false)
  const [approvalConditions, setapprovalConditions] = useState({})

  const [eiaAttachments, seteiaAttachments] = useState([])
  const [otherEnvAuditAttachments, setotherEnvAuditAttachments] = useState([])

  const [showeiaAttachments, setshoweiaAttachments] = useState(false)
  const [showOtherEnvAuditAttachments, setshowOtherEnvAuditAttachments] =
    useState(false)
  const [projectLocations, setprojectLocations] = useState([])
  const [wordCount, setWordCount] = useState(0)
  const wordLimit = 300
  const [showExtractionDate, setshowExtractionDate] = useState(false)
  const [wordCountsTextBoxes, setwordCountsTextBoxes] = useState({
    dates_of_ownership: "",
    project_aims_objective: "",
    current_number_of_staff: "",
    list_of_main_activities: "",
    list_of_main_raw_materials: "",
    process_modifications: "",
    main_activities_in_project_zone: "",
    brief_on_key_environemental_impacts: "",
    areas_of_non_compliance: "",
    major_pollution_facilities: "",
  })

  const handleInputChangeWordCount = (e, field) => {
    const words = e.target.value.trim().split(/\s+/)
    const count = words[0] === "" ? 0 : words.length
    if (count <= wordLimit) {
      setwordCountsTextBoxes({
        ...wordCountsTextBoxes,
        [field]: e.target.value,
      })
    }
  }
  const remainingWords = text => {
    const wordCount = text.trim().split(/\s+/).length
    return Math.max(0, wordLimit - wordCount)
  }

  const [isFirmIdentified, setIsFirmIdentified] = useState(false)
  const [isToRPrepared, setIsToRPrepared] = useState(false)

  // The following files must be provided before moving to the "Documents upload tab"
  const [companyRegCertificate, setcompanyRegCertificate] = useState(null)
  const [legalDocument, setlegalDocument] = useState(null)
  // This is the case where an EIA report has been issued before
  const [EIAReport, setEIAReport] = useState(null)
  // This is the case where an env audit report has been conducted before
  const [EnvironmentalAuditReport, setEnvironmentalAuditReport] = useState(null)
  const [draftToRAttachment, setdraftToRAttachment] = useState(null)

  // Sector of Activities
  const [sectorOfActivities, setsectorOfActivities] = useState([])
  const [rawSectorOfActivities, setrawSectorOfActivities] = useState([])
  const [selectedSectorOfActivity, setselectedSectorOfActivity] = useState("")

  const [submissionFailed, setsubmissionFailed] = useState(false)

  useEffect(() => {
    //console.log(subimttedFormData)
    setcancelUpload(true)
  }, [subimttedFormData])

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    setuser(userObj)
    fetchCompanies()
    fetchServiceAttachments()
    fetchSectorOfActivities()

    if (
      currentPath.includes("view-application") ||
      currentPath.includes("edit-application")
    ) {
      //show decision info card
      setshowDecisionInfo(true)
      setapplicationId(props.location.search.split("=")[1])

      environmentalAuditService
        .getApplicationDetails(props.location.search.split("=")[1])
        .then(response => {
          // console.log("submitted app details --> ", response)
          if (response.status) {
            setsubmittedFormData({
              ...response.data,
            })

            // Form fields etc
            if (response.data.application_status_id === 7) {
              setisFreshApplication(false)
              setdisableFormFields(false)
              setisReturned(true)
              setshowDocuments(true)
              seteditMode(true)
              setrenderOtherItems(true)
            } else {
              setisFreshApplication(false)
              setdisableFormFields(true)
              setshowDocuments(true)
            }

            // set some variables
            setlegalStatusType(
              response.data.environmental_audit_request.legal_status
            )

            // Comments
            let comments = ""
            let certUrl = "#"
            if (response.data.application_status_id === 7) {
              // get comments from officer
              response.data.application_flow_histories.forEach(hist => {
                if (hist.application_status_id === 7) {
                  comments = hist.comment_to_applicant
                }
              })
            }

            if (response.data.application_status_id === 6) {
              // get certificate download url
              if (
                response.data.manually_processed != undefined &&
                response.data.manually_processed == true
              ) {
                certUrl = STATIC_FILES + response.data.manually_processed.path
              } else {
                certUrl =
                  BASE_URL + "verify/certificate/" + response.data.app_id
              }
            }

            //
            // console.log("checking atts",response.data.application_attachments)
            const final_tor = response.data.application_attachments.find(
              attachment =>
                attachment.description === "Final_Terms_of_Reference"
            )

            // console.log("FINAL TOR", finaltor)
            // setfinalTOR(final_tor)

            // set decision info
            setDecisionInfo({
              statusId: response.data.application_status_id,
              status: response.data.application_status.name,
              service: response.data.service.name,
              comments: comments,
              certUrl: certUrl,
              isManuallyProcessed: response.data.manually_processed,
              manual_certificate: response.data.manual_certificate,
              finalTOR: final_tor,
              final_certificate_uploaded:
                response.data.final_certificate_uploaded,
            })

            // Set application details
            setsubmittedFormData({
              ...response.data.environmental_audit_request,
              app_id: response.data.app_id,
            })

            // check whether sector of activity is mining
            const foundMining = /mining/i.test(
              response.data.environmental_audit_request.sector_of_activity.name
            )

            if (foundMining) {
              setshowExtractionDate(true)
            } else {
              setshowExtractionDate(false)
            }
            // check whether is_rapep_firm_identified
            if (
              response.data.environmental_audit_request.is_rapep_firm_identified
            ) {
              setIsFirmIdentified(true)
            } else {
              setIsFirmIdentified(false)
            }

            // set show other activity
            if (
              response.data.environmental_audit_request.sector_of_activity ===
              "other"
            ) {
              setshowOtherSectorOfActivity(true)
            }

            // Set company Id
            if (
              response.data.environmental_audit_request.legal_status ==
              "private"
            ) {
              setcompanyId(response.data.environmental_audit_request.company.id)
            }

            // set uploaded documents
            // exclude attachments with the following descriptions
            const descriptionsToExclude = [
              "Draft_Terms_of_Reference",
              "Checklist_Review_Document",
              "Final_Terms_of_Reference",
              "Meeting_Minutes",
              "Inspection Report",
            ]

            // exclude the attachments that match any of the descriptions in the array
            const atts = response.data.application_attachments.filter(
              attachment =>
                !descriptionsToExclude.includes(attachment.description)
            )
            setUploadedImages(atts)

            const hasFinalTermsOfReference =
              response.data.application_attachments.some(
                attachment =>
                  attachment.description === "Final_Terms_of_Reference"
              )

            // Here, we're checking whether the Phase 2 component should be displayed
            const exclude_statuses = [6, 9]

            console.log("application", response.data)
            if (response.data.is_application_in_phase_2) {
              setshowPhaseTwo(true)

              if (
                response.data.environmental_audit_request.developer_phone ==
                null
              ) {
                setshowDeveloperFormModal(true)
              } else {
                setshowDeveloperFormModal(false)
              }

              // if an application is returned in Phase 2, it means we have to show developer
              // details form
              if (response.data.application_status_id == 7) {
                setisFreshApplication(false)
                setdisableFormFields(true)
                setisReturned(false)
                setshowDocuments(true)
                seteditMode(false)
                setrenderOtherItems(false)

                setshowDeveloperFormModal(true)
              }
            }

            // setshowPhaseTwo(
            //   !exclude_statuses.includes(response.data.application_status_id) &&
            //     response.data.environmental_audit_request.developer_name ===
            //       null
            // )

            // Show conditions for approval
            if (response.data.application_status_id === 18) {
              setshowApprovalConditions(true)
              setapprovalConditions({
                conditions: response.data.approval_conditions,
              })
            } else {
              setshowApprovalConditions(false)
            }

            // Toggle developer section
            if (
              response.data.environmental_audit_request.developer_phone != null
            ) {
              setshowDeveloperDetails(true)
            } else {
              setshowDeveloperDetails(false)
            }
          }
        })
    } else {
      environmentalAuditService.createApplication(userObj).then(response => {
        // console.log("response from create app --> ", response)
        setapplicationId(response.data.id)
        seteditMode(true)
      })
    }
  }, [])

  const fetchCompanies = () => {
    generalService.getCompanies().then(response => {
      // console.log(response)
      if (response.status) {
        const comps = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcompanies(comps)
      }
    })
  }

  const submitApplication = () => {
    // alert("submitting application")
    var uploaded_files = []

    setloading(true)
    uploadedFiles.forEach(attach => {
      uploaded_files.push({
        application_id: applicationId,
        description: attach.description,
        file: attach.file,
      })
    })

    environmentalAuditService
      .saveApplication({
        ...applicationDetails,
        has_eia_conducted_before: JSON.parse(
          applicationDetails.has_eia_conducted_before
        ),
        has_environmental_audit_conducted_before: JSON.parse(
          applicationDetails.has_environmental_audit_conducted_before
        ),
        premises_owned: JSON.parse(applicationDetails.premises_owned),
        tor_drafted: JSON.parse(applicationDetails.tor_drafted),
        is_rapep_firm_identified: JSON.parse(
          applicationDetails.is_rapep_firm_identified
        ),

        application_id: applicationId,

        // fields removed as at Jan 13, 2025
        list_of_main_products: "N/A",
        water_supply: false,
        electricity_supply: false,
        brief_on_generated_wastes: "N/A",
        brief_on_emissions: "N/A",
        received_claims: "N/A",
        environmental_breach_record: "N/A",
        road_access: false,
        area: 0,
        sector_of_activity: "N/A", // we are now passing sector_of_activity_id (Aime to remove this field)
      })
      .then(response => {
        console.log("save application response", response)
        if (!response.status) {
          setsubmissionFailed(true)
          seterror("Error encountered while submitting application")
          setloading(false)
        } else {
          setsubmissionFailed(false)
        }
        if (response) {
          // if (isReturned && !showDocuments) {
          //   plasticsApp.bulkFileUpload(uploaded_files)
          // } else if (isFreshApplication) {
          //   plasticsApp.bulkFileUpload(uploaded_files)
          // }
          // save project locations
          // submitOtherProjectLocations()
          environmentalAuditService.bulkFileUpload(uploaded_files)
          uploadTabOneFiles()
          setsubmitted(true)
        } else {
          seterror("Error encountered while submitting application")
          setloading(false)
        }
      })
  }

  const validateApplicationDetails = formData => {
    // console.log("form-data")
    // console.log(formData)

    setApplicationDetails({ ...formData, ...projectLocationNames })
    setactiveTab(2)
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab)
      }
    }
  }

  const fetchServiceAttachments = () => {
    const attachments = EnvironmentalAuditAttachments.map(
      (attachment, index) => (
        <Row key={index}>
          <span>{attachment.description}</span>
          {attachment.info && attachment.info != "" ? (
            <i style={{ color: "blue" }}>{attachment.info}</i>
          ) : null}
          <input
            type="file"
            className="form-control"
            //onChange={onChangeProductImage}
            id={attachment.name}
            required={attachment.is_mandatory}
            accept=".pdf,image/*"
          />
        </Row>
      )
    )
    setserviceAttachments(attachments)

    const _eaiattachments = EIA_Attachments.map((attachment, index) => (
      <Row key={index}>
        <span>{attachment.description}</span>
        {attachment.info && attachment.info != "" ? (
          <i style={{ color: "blue" }}>{attachment.info}</i>
        ) : null}
        <input
          type="file"
          //onChange={onChangeProductImage}
          id={attachment.name}
          required={attachment.is_mandatory}
          accept=".pdf"
        />
      </Row>
    ))
    seteiaAttachments(_eaiattachments)

    const _otherEnvAuditAttachments = Other_Env_Audit_Attachments.map(
      (attachment, index) => (
        <Row key={index}>
          <span>{attachment.description}</span>
          {attachment.info && attachment.info != "" ? (
            <i style={{ color: "blue" }}>{attachment.info}</i>
          ) : null}
          <input
            type="file"
            className="form-control"
            //onChange={onChangeProductImage}
            id={attachment.name}
            required={attachment.is_mandatory}
            accept=".pdf"
          />
        </Row>
      )
    )

    setotherEnvAuditAttachments(_otherEnvAuditAttachments)

    // const [showeiaAttachments, setshoweiaAttachments] =  useState(false)
    // const [showOtherEnvAuditAttachments, setshowOtherEnvAuditAttachments] =  useState(false)
  }

  const handleHasEIABeenConducted = e => {
    // console.log(e.target.value)
    if (e.target.value === "true") {
      setshoweiaAttachments(true)
    } else {
      setshoweiaAttachments(false)
    }
  }

  const handleHasOtherAuditBeenConducted = e => {
    if (e.target.value === "true") {
      setshowOtherEnvAuditAttachments(true)
    } else {
      setshowOtherEnvAuditAttachments(false)
    }
  }

  const prepareUploadFiles = e => {
    let current_attachments = []
    let kount = 0
    let total_files = serviceAttachments.length
    if (showeiaAttachments) {
      total_files += eiaAttachments.length
    }
    if (showOtherEnvAuditAttachments) {
      total_files += otherEnvAuditAttachments.length
    }
    for (kount = 0; kount < total_files; kount++) {
      if (e.target[kount].files.length > 0) {
        current_attachments.push({
          application_id: applicationId,
          description: e.target[kount].id,
          file: e.target[kount].files[0],
        })
      }
    }
    // console.log("upload files", current_attachments)
    setuploadedFiles(current_attachments)
    setactiveTab(3)
  }

  const initiateReupload = () => {
    setshowDocuments(false)
    setcancelUpload(false)
  }

  const showUploadedFiles = () => {
    setcancelUpload(false)
    setshowDocuments(true)
  }

  // handlers to get the project location names (province, district, cell, )
  // Update handler for sector
  const onChangeSector = value => {
    setProjectLocationNames(prevState => ({
      ...prevState,
      sector: value,
    }))
  }

  // Update handler for cell
  const onChangeCell = value => {
    setProjectLocationNames(prevState => ({
      ...prevState,
      cell: value,
    }))
  }

  // Update handler for village
  const onChangeVillage = value => {
    setProjectLocationNames(prevState => ({
      ...prevState,
      village: value,
    }))
  }

  // Update handler for district
  const onChangeDistrict = value => {
    setProjectLocationNames(prevState => ({
      ...prevState,
      district: value,
    }))
  }

  // Update handler for province
  const onChangeProvince = value => {
    setProjectLocationNames(prevState => ({
      ...prevState,
      province: value,
    }))
  }

  const handleSectorOfActivityChange = e => {
    // console.log("showOtherSectorOfActivity", showOtherSectorOfActivity)

    if (e.target.value === "other") {
      setshowOtherSectorOfActivity(true)
    } else {
      setshowOtherSectorOfActivity(false)
      const selectedSector = rawSectorOfActivities.find(
        item => item.is_active && item.id == e.target.value
      )?.name
      setselectedSectorOfActivity(selectedSector)
    }
    //
    if (containsMiningInActivities(e.target.value)) {
      setshowExtractionDate(true)
    } else {
      setshowExtractionDate(false)
    }
  }

  const handleLocationsChange = locations => {
    setprojectLocations(locations)
    // console.log("locations from parent", locations)
  }

  const submitOtherProjectLocations = () => {
    environmentalAuditService
      .submitProjectLocations(projectLocations)
      .then(response => {
        console.log("response after submitting locs", response)
      })
  }

  const getOtherProjectLocations = appId => {
    environmentalAuditService.getProjectLocations(appId).then(response => {
      // console.log("locations", response)
      if (response.status) {
        if (response.data[0] != null) {
          setprojectLocations(response.data)
        }
      }
    })
  }

  // custom uploads
  // const [companyRegCertificate, setcompanyRegCertificate] = useState(null)
  // const [legalDocument, setlegalDocument] = useState(null)
  // const [EIAReport, setEIAReport] = useState(null)
  // const [draftToRAttachment, setdraftToRAttachment] = useState(null)

  const uploadTabOneFiles = () => {
    var uploaded_files = []

    if (EIAReport != null) {
      uploaded_files.push({
        application_id: applicationId,
        description: "EIA Report",
        file: EIAReport,
      })
    }

    if (EnvironmentalAuditReport != null) {
      uploaded_files.push({
        application_id: applicationId,
        description: "Environmental Audit Report",
        file: EnvironmentalAuditReport,
      })
    }
    
    if (companyRegCertificate != null) {
      uploaded_files.push({
        application_id: applicationId,
        description: "Company Registration Certificate",
        file: companyRegCertificate,
      })
    }

    if (legalDocument != null) {
      uploaded_files.push({
        application_id: applicationId,
        description: "Legal Document",
        file: legalDocument,
      })
    }

    if (draftToRAttachment != null) {
      uploaded_files.push({
        application_id: applicationId,
        description: "Draft ToR Attachment",
        file: draftToRAttachment,
      })
    }

    environmentalAuditService.bulkFileUpload(uploaded_files)
  }

  const fetchSectorOfActivities = () => {
    environmentalAuditService.getSectorOfActivities().then(response => {
      if (response.status) {
        const acts = response.data
          .filter(item => item.is_active) // Filter active items
          .map(item => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))
        setsectorOfActivities(acts)
        setrawSectorOfActivities(response.data)
      }
    })
  }

  const containsMiningInActivities = id => {
    const foundItem = rawSectorOfActivities.find(
      item => item.is_active && item.id == id && /mining/i.test(item.name)
    )
    return !!foundItem // Returns true if a match is found
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Apply | Environmental Audit</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="Dashboard"
            title="Application"
            breadcrumbItem="Environmental Audit"
          />

          {showPhaseTwo ? (
            <Row>
              <div>
              <Alert color="info">
              <h6>
                Download Approved ToRs{" "}
                <a
                  href={BASE_URL + "verify/tor/" + subimttedFormData.app_id}
                  target="_blank"
                >
                  here
                </a>
                .
              </h6>
              </Alert>
              </div>
              
            </Row>
          ) : null}

          {showDeveloperFormModal ? (
            <Row>
              <AuditPhaseTwo applicationDetails={subimttedFormData} />
              <br></br>
            </Row>
          ) : null}

          {showApprovalConditions ? (
            <Row>
              <ConditionsOfApproval
                approval_conditions={approvalConditions}
                applicationDetails={subimttedFormData}
              />
              <br></br>
            </Row>
          ) : null}

          {showDecisionInfo ? (
            <Row>
              <Col sm="12">
                <DecisionInfo data={decisionInfo} />
              </Col>
            </Row>
          ) : (
            ""
          )}

          {!submitted ? (
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">
                      Request for Environmental Audit
                    </h4>
                    <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                      <div className="steps clearfix">
                        <ul>
                          <NavItem
                            className={classnames({ current: activeTab === 1 })}
                          >
                            <NavLink
                              className={classnames({
                                current: activeTab === 1,
                              })}
                              onClick={() => {
                                //setactiveTab(1)
                              }}
                            >
                              <span className="number">1.</span> Application
                              Details
                            </NavLink>
                          </NavItem>
                          <NavItem
                            className={classnames({ current: activeTab === 2 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 2,
                              })}
                              onClick={() => {
                                //setactiveTab(2)
                              }}
                            >
                              <span className="number">2.</span> Document
                              Uploads
                            </NavLink>
                          </NavItem>

                          <NavItem
                            className={classnames({ current: activeTab === 3 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 3,
                              })}
                              onClick={() => {
                                //setactiveTab(3)
                              }}
                            >
                              <span className="number">3.</span>
                              Confirm Detail
                            </NavLink>
                          </NavItem>
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <TabContent activeTab={activeTab} className="body">
                          <TabPane tabId={1}>
                            <AvForm
                              onValidSubmit={(e, v) => {
                                validateApplicationDetails(v)
                              }}
                              model={subimttedFormData}
                            >
                              {error ? (
                                <Alert color="danger">{error}</Alert>
                              ) : null}

                              <Row>
                                <h4>Section 1: Project Location</h4>
                                <ProjectLocation
                                  data={subimttedFormData}
                                  disableFormFields={disableFormFields}
                                  onChangeSector={onChangeSector}
                                  onChangeCell={onChangeCell}
                                  onChangeVillage={onChangeVillage}
                                  onChangeDistrict={onChangeDistrict}
                                  onChangeProvince={onChangeProvince}
                                  projectLocationNames={projectLocationNames}
                                />

                                <Row>
                                  <Col md={6}>
                                    <AvField
                                      name="longitude"
                                      label="Longitude"
                                      type="text"
                                      placeholder="Enter longitude"
                                      value={
                                        subimttedFormData.longitude
                                          ? subimttedFormData.longitude
                                          : ""
                                      }
                                      readOnly={disableFormFields}
                                      validate={{
                                        required: {
                                          value: false,
                                          errorMessage: "Longitude is required",
                                        },
                                        pattern: {
                                          value:
                                            "^-?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?)$",
                                          errorMessage:
                                            "Enter a valid longitude (-180 to 180)",
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col md={6}>
                                    <AvField
                                      name="latitude"
                                      label="Latitude"
                                      type="text"
                                      placeholder="Enter latitude"
                                      value={
                                        subimttedFormData.latitude
                                          ? subimttedFormData.latitude
                                          : ""
                                      }
                                      readOnly={disableFormFields}
                                      validate={{
                                        required: {
                                          value: false,
                                          errorMessage: "Latitude is required",
                                        },
                                        pattern: {
                                          value:
                                            "^-?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?)$",
                                          errorMessage:
                                            "Enter a valid latitude (-90 to 90)",
                                        },
                                      }}
                                    />
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={6}>
                                    <Row className="mb-3">
                                      <div>
                                        <br></br>
                                        <AvField
                                          type="text"
                                          name="upi"
                                          label="Enter the Unique Parcel Identifier (UPI)"
                                          disabled={disableFormFields}
                                          value={
                                            subimttedFormData.upi
                                              ? subimttedFormData.upi
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                  <Col md={6}>
                                    <Row className="mb-3">
                                      <div>
                                        <br></br>
                                        <AvField
                                          type="text"
                                          name="zoning_of_project"
                                          label="Zoning of the project (National Land Use Master Plan, City of Kigali Master Plan, and District Land Use Master Plan)."
                                          required
                                          disabled={disableFormFields}
                                          value={
                                            subimttedFormData.zoning_of_project
                                              ? subimttedFormData.zoning_of_project
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              </Row>
                              <hr></hr>
                              <Row>
                                <h4>Section 2: Project Description</h4>
                                <Row>
                                  <Col md={6}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          type="select"
                                          name="legal_status"
                                          label="Project Owner"
                                          value={legalStatusType}
                                          required
                                          disabled={disableFormFields}
                                          onChange={e => {
                                            setlegalStatusType(e.target.value)
                                          }}
                                        >
                                          <option value="">--select--</option>
                                          <option value="individual">
                                            Individual
                                          </option>
                                          <option value="private">
                                            Company/Enterprise
                                          </option>
                                          <option value="cooperative">
                                            Cooperative
                                          </option>
                                          <option value="government">
                                            Government Institution
                                          </option>
                                        </AvField>
                                      </div>
                                    </Row>
                                  </Col>

                                  {legalStatusType === "individual" ? (
                                    <>
                                      <Col md={6}>
                                        <Row className="mb-3">
                                          <div>
                                            <AvField
                                              type="text"
                                              name="tin"
                                              label="Identification Number"
                                              value={
                                                subimttedFormData.tin
                                                  ? subimttedFormData.tin
                                                  : ""
                                              }
                                              required
                                              disabled={disableFormFields}
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Row>
                                        <ApplicantDetails />
                                      </Row>
                                    </>
                                  ) : (
                                    <Col md="6">
                                      {legalStatusType === "private" ? (
                                        <>
                                          <Row>
                                            <AvField
                                              type="select"
                                              name="company_id"
                                              label="Select Company"
                                              required
                                              value={companyId}
                                              disabled={disableFormFields}
                                            >
                                              <option>--Select Company</option>
                                              {companies}
                                            </AvField>
                                          </Row>
                                        </>
                                      ) : null}
                                    </Col>
                                  )}
                                </Row>

                                {(legalStatusType === "cooperative" ||
                                  legalStatusType === "government") && (
                                  <InstitutionDetails
                                    disableFormFields={disableFormFields}
                                    data={subimttedFormData}
                                  />
                                )}

                                {legalStatusType != "individual" ? (
                                  <AvField
                                    type="number"
                                    name="year_of_establishment"
                                    label="Year of Establishment"
                                    readOnly={disableFormFields}
                                    value={
                                      subimttedFormData.year_of_establishment
                                        ? subimttedFormData.year_of_establishment
                                        : ""
                                    }
                                    required
                                  ></AvField>
                                ) : null}
                                <hr></hr>
                              </Row>
                              {/* Legal Document */}
                              <Row>
                                {editMode ? (
                                  <Col md={12}>
                                    <AvField
                                      className="form-control"
                                      name="legalDocument"
                                      label="Legal Document"
                                      type="file"
                                      onChange={e => {
                                        const file = e.target.files[0]
                                        if (file) {
                                          setlegalDocument(file)
                                        }
                                      }}
                                      accept=".pdf"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage:
                                            "Legal document is required",
                                        },
                                      }}
                                    />
                                  </Col>
                                ) : null}
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <br></br>
                                      <AvField
                                        type="text"
                                        name="title_of_project"
                                        label="Title of Project"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.title_of_project
                                            ? subimttedFormData.title_of_project
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col>

                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <br></br>
                                      <AvField
                                        type="date"
                                        name="date_of_commencement"
                                        label="Project starting date"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.date_of_commencement
                                            ? subimttedFormData.date_of_commencement
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col>

                                {/* Developer details */}
                                {showDeveloperDetails ? (
                                  <>
                                    <Col md={6}>
                                      <Row className="mb-3">
                                        <div>
                                          <AvField
                                            type="text"
                                            name="developer_name"
                                            label="Name of Developer"
                                            required
                                            disabled={disableFormFields}
                                            value={
                                              subimttedFormData.developer_name
                                                ? subimttedFormData.developer_name
                                                : ""
                                            }
                                          />
                                        </div>
                                      </Row>
                                    </Col>
                                    <Col md={6}>
                                      <Row className="mb-3">
                                        <div>
                                          <AvField
                                            type="text"
                                            name="developer_email"
                                            label="Developer Email"
                                            required
                                            disabled={disableFormFields}
                                            value={
                                              subimttedFormData.developer_email
                                                ? subimttedFormData.developer_email
                                                : ""
                                            }
                                          />
                                        </div>
                                      </Row>
                                    </Col>
                                  </>
                                ) : null}
                              </Row>

                              {showDeveloperDetails ? (
                                <Row>
                                  <Col md={4}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          type="text"
                                          name="developer_phone"
                                          label="Firm/Expert Phone Number"
                                          required
                                          disabled={disableFormFields}
                                          value={
                                            subimttedFormData.developer_phone
                                              ? subimttedFormData.developer_phone
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                  <Col md={4}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          type="text"
                                          name="developer_address"
                                          label="Address of Firm/Expert "
                                          required
                                          disabled={disableFormFields}
                                          value={
                                            subimttedFormData.developer_address
                                              ? subimttedFormData.developer_address
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Row>
                                  </Col>

                                  <Col md={4}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          type="text"
                                          name="developer_rapep_number"
                                          label="Firm/Expert RAPEP Number"
                                          required
                                          disabled={disableFormFields}
                                          value={
                                            subimttedFormData.developer_rapep_number
                                              ? subimttedFormData.developer_rapep_number
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              ) : null}
                              <hr></hr>
                              <Row>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <AvField
                                      name="sector_of_activity_name"
                                      type="hidden"
                                      value={selectedSectorOfActivity}
                                    ></AvField>
                                    <div>
                                      <AvField
                                        type="select"
                                        name="sector_of_activity_id"
                                        label="Sector of Activity"
                                        required
                                        onChange={handleSectorOfActivityChange}
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.sector_of_activity_id
                                            ? subimttedFormData.sector_of_activity_id
                                            : ""
                                        }
                                      >
                                        <option value="">
                                          Select an activity
                                        </option>
                                        {sectorOfActivities}

                                        {/* <option value="other">Other</option> */}
                                      </AvField>
                                      {showOtherSectorOfActivity == true ? (
                                        <AvField
                                          type="text"
                                          name="other_sector_of_activity"
                                          label="Please specify"
                                          required
                                          disabled={disableFormFields}
                                          value={
                                            subimttedFormData.other_sector_of_activity ||
                                            ""
                                          }
                                        />
                                      ) : null}
                                    </div>

                                    {showExtractionDate ? (
                                      <Row>
                                        <Col md={12}>
                                          <AvField
                                            name="extraction_date"
                                            label="Extraction Date"
                                            type="date"
                                            value={
                                              subimttedFormData.extraction_date ||
                                              ""
                                            }
                                            disabled={disableFormFields}
                                            validate={{
                                              required: {
                                                value: true,
                                                errorMessage:
                                                  "Extraction date is required",
                                              },
                                            }}
                                          />
                                        </Col>
                                      </Row>
                                    ) : null}
                                  </Row>
                                </Col>
                                {/* Boolean Question: Are the premises owned? */}

                                <Col md={6}>
                                  <label>Are the premises owned?</label>
                                  <AvField
                                    type="select"
                                    name="premises_owned"
                                    required
                                    errorMessage="Please select Yes or No"
                                    disabled={disableFormFields}
                                    value={
                                      subimttedFormData
                                        ? String(
                                            subimttedFormData.premises_owned
                                          )
                                        : ""
                                    }
                                  >
                                    <option>--Select--</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                  </AvField>
                                </Col>
                              </Row>
                              {/* Premises */}

                              {/* End Premises */}
                              <Row>
                                {/* Textarea: Indicate dates, ownership, and uses */}
                                <Col md={12}>
                                  <AvField
                                    name="dates_of_ownership"
                                    label="Indicate the dates, ownership, and use(s) of the properties prior to the date of acquisition or lease by this organization"
                                    type="textarea"
                                    rows="4"
                                    disabled={disableFormFields}
                                    placeholder="Provide details here"
                                    value={
                                      subimttedFormData.dates_of_ownership ||
                                      wordCountsTextBoxes["dates_of_ownership"]
                                    }
                                    onChange={e =>
                                      handleInputChangeWordCount(
                                        e,
                                        "dates_of_ownership"
                                      )
                                    }
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "This field is required",
                                      },
                                    }}
                                  />
                                  <small className="text-muted">
                                    Remaining words:{" "}
                                    {remainingWords(
                                      wordCountsTextBoxes["dates_of_ownership"]
                                    )}{" "}
                                  </small>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <AvField
                                    name="project_aims_objective"
                                    label={`Project aims, objectives, and size (Limit: ${wordLimit} words)`}
                                    type="textarea"
                                    rows="6"
                                    value={
                                      subimttedFormData.project_aims_objective ||
                                      wordCountsTextBoxes[
                                        "project_aims_objective"
                                      ]
                                    }
                                    disabled={disableFormFields}
                                    placeholder="Describe the project here (300 words max)"
                                    onChange={e =>
                                      handleInputChangeWordCount(
                                        e,
                                        "project_aims_objective"
                                      )
                                    }
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "This field is required",
                                      },
                                      maxLength: {
                                        value: wordLimit * 6, // Approx. 6 characters per word
                                        errorMessage: `Word limit exceeded. Please limit your description to ${wordLimit} words.`,
                                      },
                                    }}
                                  />
                                  <small className="text-muted">
                                    Remaining words:{" "}
                                    {remainingWords(
                                      wordCountsTextBoxes[
                                        "project_aims_objective"
                                      ]
                                    )}{" "}
                                  </small>
                                </Col>
                              </Row>

                              <Row>
                                {/* Textarea: Current and planned staff */}
                                <Col md={12}>
                                  <AvField
                                    name="current_number_of_staff"
                                    label="Provide the current number of staff at the premises and those planned in the future (by department or location: Professional; Technical/Field; Others (specify))"
                                    type="textarea"
                                    rows="4"
                                    disabled={disableFormFields}
                                    value={
                                      subimttedFormData.current_number_of_staff ||
                                      wordCountsTextBoxes[
                                        "current_number_of_staff"
                                      ]
                                    }
                                    onChange={e =>
                                      handleInputChangeWordCount(
                                        e,
                                        "current_number_of_staff"
                                      )
                                    }
                                    placeholder="Provide details here"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "This field is required",
                                      },
                                    }}
                                  />
                                  <small className="text-muted">
                                    Remaining words:{" "}
                                    {remainingWords(
                                      wordCountsTextBoxes[
                                        "current_number_of_staff"
                                      ]
                                    )}{" "}
                                  </small>
                                </Col>
                              </Row>

                              <Row>
                                <>
                                  <Col md={6}>
                                    <AvField
                                      type="textarea"
                                      name="list_of_main_activities"
                                      label="List the main activities of the project"
                                      required
                                      disabled={disableFormFields}
                                      rows={5}
                                      value={
                                        subimttedFormData.list_of_main_activities
                                          ? subimttedFormData.list_of_main_activities
                                          : wordCountsTextBoxes[
                                              "list_of_main_activities"
                                            ]
                                      }
                                      onChange={e =>
                                        handleInputChangeWordCount(
                                          e,
                                          "list_of_main_activities"
                                        )
                                      }
                                    />
                                    <small className="text-muted">
                                      Remaining words:{" "}
                                      {remainingWords(
                                        wordCountsTextBoxes[
                                          "list_of_main_activities"
                                        ]
                                      )}{" "}
                                    </small>
                                  </Col>
                                </>
                                <>
                                  <Col md={6}>
                                    <AvField
                                      type="textarea"
                                      name="list_of_main_raw_materials"
                                      label="List the main raw materials"
                                      required
                                      disabled={disableFormFields}
                                      rows={5}
                                      value={
                                        subimttedFormData.list_of_main_raw_materials
                                          ? subimttedFormData.list_of_main_raw_materials
                                          : wordCountsTextBoxes[
                                              "list_of_main_raw_materials"
                                            ]
                                      }
                                      onChange={e =>
                                        handleInputChangeWordCount(
                                          e,
                                          "list_of_main_raw_materials"
                                        )
                                      }
                                    />
                                    <small className="text-muted">
                                      Remaining words:{" "}
                                      {remainingWords(
                                        wordCountsTextBoxes[
                                          "list_of_main_raw_materials"
                                        ]
                                      )}{" "}
                                    </small>
                                  </Col>
                                </>
                              </Row>
                              <Row>
                                {/* Optional Textarea: Process modifications or expansions */}
                                <Col md={12}>
                                  <AvField
                                    name="process_modifications"
                                    label="State any process modifications or expansions currently being planned (Optional)"
                                    type="textarea"
                                    disabled={disableFormFields}
                                    rows="4"
                                    placeholder="Provide details here (optional)"
                                    value={
                                      subimttedFormData.process_modifications ||
                                      wordCountsTextBoxes[
                                        "process_modifications"
                                      ]
                                    }
                                    onChange={e =>
                                      handleInputChangeWordCount(
                                        e,
                                        "process_modifications"
                                      )
                                    }
                                  />
                                  <small className="text-muted">
                                    Remaining words:{" "}
                                    {remainingWords(
                                      wordCountsTextBoxes[
                                        "process_modifications"
                                      ]
                                    )}{" "}
                                  </small>
                                </Col>
                              </Row>
                              <br></br>
                              <Row>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="textarea"
                                        name="main_activities_in_project_zone"
                                        label="Main activities in the project zone"
                                        required
                                        disabled={disableFormFields}
                                        rows={5}
                                        value={
                                          subimttedFormData.main_activities_in_project_zone
                                            ? subimttedFormData.main_activities_in_project_zone
                                            : wordCountsTextBoxes[
                                                "main_activities_in_project_zone"
                                              ]
                                        }
                                        onChange={e =>
                                          handleInputChangeWordCount(
                                            e,
                                            "main_activities_in_project_zone"
                                          )
                                        }
                                      />
                                      <small className="text-muted">
                                        Remaining words:{" "}
                                        {remainingWords(
                                          wordCountsTextBoxes[
                                            "main_activities_in_project_zone"
                                          ]
                                        )}{" "}
                                      </small>
                                    </div>
                                  </Row>
                                </Col>

                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="textarea"
                                        name="brief_on_key_environemental_impacts"
                                        label="Highlight areas of environmental concerns at the premises including any areas of regulatory uncertainties"
                                        // required
                                        disabled={disableFormFields}
                                        rows={5}
                                        value={
                                          subimttedFormData.brief_on_key_environemental_impacts
                                            ? subimttedFormData.brief_on_key_environemental_impacts
                                            : wordCountsTextBoxes[
                                                "brief_on_key_environemental_impacts"
                                              ]
                                        }
                                        onChange={e =>
                                          handleInputChangeWordCount(
                                            e,
                                            "brief_on_key_environemental_impacts"
                                          )
                                        }
                                      />
                                      <small className="text-muted">
                                        Remaining words:{" "}
                                        {remainingWords(
                                          wordCountsTextBoxes[
                                            "brief_on_key_environemental_impacts"
                                          ]
                                        )}{" "}
                                      </small>
                                    </div>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                {/* Optional: Non-compliance areas */}
                                <Col md={12}>
                                  <AvField
                                    name="areas_of_non_compliance"
                                    label="List any areas of non-compliance associated with your operations over the last six months (Optional)"
                                    type="textarea"
                                    rows="4"
                                    disabled={disableFormFields}
                                    placeholder="Provide details here (optional)"
                                    value={
                                      subimttedFormData.areas_of_non_compliance ||
                                      wordCountsTextBoxes[
                                        "areas_of_non_compliance"
                                      ]
                                    }
                                    onChange={e =>
                                      handleInputChangeWordCount(
                                        e,
                                        "areas_of_non_compliance"
                                      )
                                    }
                                  />
                                  <small className="text-muted">
                                    Remaining words:{" "}
                                    {remainingWords(
                                      wordCountsTextBoxes[
                                        "areas_of_non_compliance"
                                      ]
                                    )}{" "}
                                  </small>
                                </Col>
                              </Row>

                              <Row>
                                {/* Required: Pollution facilities */}
                                <Col md={12}>
                                  <AvField
                                    name="major_pollution_facilities"
                                    label="Describe the major pollution facilities employed at your site and those planned in the future"
                                    type="textarea"
                                    disabled={disableFormFields}
                                    rows="6"
                                    placeholder="Provide details here"
                                    value={
                                      subimttedFormData.major_pollution_facilities ||
                                      wordCountsTextBoxes[
                                        "major_pollution_facilities"
                                      ]
                                    }
                                    onChange={e =>
                                      handleInputChangeWordCount(
                                        e,
                                        "major_pollution_facilities"
                                      )
                                    }
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "This field is required",
                                      },
                                    }}
                                  />
                                  <small className="text-muted">
                                    Remaining words:{" "}
                                    {remainingWords(
                                      wordCountsTextBoxes[
                                        "major_pollution_facilities"
                                      ]
                                    )}{" "}
                                  </small>
                                </Col>
                              </Row>
                              {/* <Row>
                                <br></br>
                                <Col md={6}>
                                  <AvField
                                    type="textarea"
                                    name="list_of_main_products"
                                    label="Main Products/Services and Quantities"
                                    required
                                    disabled={disableFormFields}
                                    rows={5}
                                    value={
                                      subimttedFormData.list_of_main_products
                                        ? subimttedFormData.list_of_main_products
                                        : ""
                                    }
                                  />
                                </Col>
                              </Row> */}
                              <br></br>
                              <Row>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="has_eia_conducted_before"
                                        label="Has an EIA been conducted prior to the project?"
                                        required
                                        disabled={disableFormFields}
                                        onChange={handleHasEIABeenConducted}
                                        value={
                                          subimttedFormData
                                            ? String(
                                                subimttedFormData.has_eia_conducted_before
                                              )
                                            : ""
                                        }
                                      >
                                        <option>
                                          ---------Select----------
                                        </option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                      </AvField>
                                    </div>
                                    {showeiaAttachments ? (
                                      <>
                                        <Col md={12}>
                                          <AvField
                                            className="form-control"
                                            name="EIAReport"
                                            label="EIA Report and certificate with conditions of approval"
                                            type="file"
                                            onChange={e => {
                                              const file = e.target.files[0]
                                              if (file) {
                                                setEIAReport(file)
                                              }
                                            }}
                                            accept=".pdf"
                                            validate={{
                                              required: {
                                                value: true,
                                                errorMessage:
                                                  "EIA report is required",
                                              },
                                            }}
                                          />
                                        </Col>
                                      </>
                                    ) : null}
                                  </Row>
                                </Col>

                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="has_environmental_audit_conducted_before"
                                        label="Has any other Environmental Audit been conducted before?"
                                        required
                                        disabled={disableFormFields}
                                        onChange={
                                          handleHasOtherAuditBeenConducted
                                        }
                                        value={
                                          subimttedFormData
                                            ? String(
                                                subimttedFormData.has_environmental_audit_conducted_before
                                              )
                                            : ""
                                        }
                                      >
                                        <option>
                                          ---------Select----------
                                        </option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                      </AvField>
                                    </div>

                                    {showOtherEnvAuditAttachments ? (
                                      <>
                                        <Col md={12}>
                                          <AvField
                                            className="form-control"
                                            name="EnvironmentalAuditReport"
                                            label="Environmental audit report and certificate with conditions of approval"
                                            type="file"
                                            onChange={e => {
                                              const file = e.target.files[0]
                                              if (file) {
                                                setEnvironmentalAuditReport(
                                                  file
                                                )
                                              }
                                            }}
                                            accept=".pdf"
                                            validate={{
                                              required: {
                                                value: true,
                                                errorMessage:
                                                  "Environmental audit is required",
                                              },
                                            }}
                                          />
                                        </Col>
                                      </>
                                    ) : null}
                                  </Row>
                                </Col>
                              </Row>
                              <hr></hr>
                              <Row>
                                {/* Question: Approved Firm Identified */}
                                <Col md={12}>
                                  <label>
                                    Have you identified an approved Firm
                                    registered in RAPEP to conduct EA Study?
                                  </label>

                                  <AvField
                                    type="select"
                                    name="is_rapep_firm_identified"
                                    required
                                    errorMessage="Please select Yes or No"
                                    disabled={disableFormFields}
                                    onChange={e =>
                                      setIsFirmIdentified(
                                        e.target.value === "true"
                                      )
                                    }
                                    value={
                                      subimttedFormData
                                        ? String(
                                            subimttedFormData.is_rapep_firm_identified
                                          )
                                        : ""
                                    }
                                  >
                                    <option>--Select--</option>
                                    <option value={"true"}>Yes</option>
                                    <option value={"false"}>No</option>
                                  </AvField>
                                </Col>
                              </Row>

                              {isFirmIdentified && (
                                <>
                                  {/* Firm Details Section */}
                                  <Row>
                                    <Col md={6}>
                                      <AvField
                                        name="developer_name"
                                        label="Firm/Company Name"
                                        type="text"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "This field is required",
                                          },
                                        }}
                                        value={
                                          subimttedFormData.developer_name || ""
                                        }
                                      />
                                    </Col>
                                    <Col md={6}>
                                      <AvField
                                        name="developer_rapep_number"
                                        label="RAPEP Registration Number (License)"
                                        type="text"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "This field is required",
                                          },
                                        }}
                                        value={
                                          subimttedFormData.developer_rapep_number ||
                                          ""
                                        }
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={6}>
                                      <AvField
                                        name="developer_representative"
                                        label="Company Representative Name"
                                        type="text"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "This field is required",
                                          },
                                        }}
                                        value={
                                          subimttedFormData.developer_representative ||
                                          ""
                                        }
                                      />
                                    </Col>
                                    {editMode ? (
                                      <Col md={6}>
                                        <AvField
                                          name="companyRegCertificate"
                                          label="Firm/Company Representative (Attachment of Certificate of Company Registration)"
                                          type="file"
                                          className="form-control"
                                          accept=".pdf"
                                          onChange={e => {
                                            const file = e.target.files[0]
                                            if (file) {
                                              setcompanyRegCertificate(file)
                                            }
                                          }}
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage:
                                                "Please upload the certificate",
                                            },
                                          }}
                                        />
                                      </Col>
                                    ) : null}
                                  </Row>
                                </>
                              )}

                              <Row>
                                {/* Question: Draft ToRs Prepared */}
                                <Col md={12}>
                                  <label>Have you prepared draft ToRs?</label>
                                  <AvField
                                    type="select"
                                    name="tor_drafted"
                                    required
                                    errorMessage="Please select Yes or No"
                                    disabled={disableFormFields}
                                    value={
                                      subimttedFormData
                                        ? String(subimttedFormData.tor_drafted)
                                        : ""
                                    }
                                    onChange={e =>
                                      setIsToRPrepared(
                                        e.target.value === "true"
                                      )
                                    }
                                  >
                                    <option>--Select--</option>
                                    <option value={"true"}>Yes</option>
                                    <option value={"false"}>No</option>
                                  </AvField>
                                </Col>
                              </Row>

                              {isToRPrepared && (
                                <Row>
                                  <Col md={12}>
                                    <br></br>
                                    <AvField
                                      name="draftToRAttachment"
                                      label="Attachment (Optional)"
                                      type="file"
                                      className="form-control"
                                      onChange={e => {
                                        const file = e.target.files[0]
                                        if (file) {
                                          setdraftToRAttachment(file)
                                        }
                                      }}
                                      accept=".pdf,.doc,.docx"
                                    />
                                  </Col>
                                </Row>
                              )}

                              {/* <Row>
                                <ProjectLocation
                                  data={subimttedFormData}
                                  disableFormFields={disableFormFields}
                                  onChangeSector={onChangeSector}
                                  onChangeCell={onChangeCell}
                                  onChangeDistrict={onChangeDistrict}
                                  onChangeProvince={onChangeProvince}
                                  projectLocationNames={projectLocationNames}
                                />
                              </Row> */}

                              {/* <Row>
                                <MultiProjectLocations
                                  appId={applicationId}
                                  locations={projectLocations}
                                  handleLocationsChange={handleLocationsChange}
                                  disableFormFields={disableFormFields}
                                />
                              </Row> */}

                              <hr></hr>
                              <Row>
                                {/* <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="text"
                                        name="upi"
                                        label="Enter the Unique Parcel Identifier (UPI)"
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.upi
                                            ? subimttedFormData.upi
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col> */}
                                {/* <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="number"
                                        name="area"
                                        label="Add area in square meters"
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.area
                                            ? subimttedFormData.area
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col> */}
                              </Row>
                              <Row>
                                {/* <Col md={4}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="text"
                                        name="project_categorization"
                                        label="Location"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                            subimttedFormData.project_categorization
                                              ? subimttedFormData.project_categorization
                                              : ""
                                          }
                                      />
                                    </div>
                                  </Row>
                                </Col> */}

                                {/* <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="text"
                                        name="zoning_of_project"
                                        label="Zoning of the project in the national land use master plan/ City of Kigali master plan"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.zoning_of_project
                                            ? subimttedFormData.zoning_of_project
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col> */}

                                {/* <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="water_supply"
                                        label="Water Supply Status"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData
                                            ? String(
                                                subimttedFormData.water_supply
                                              )
                                            : ""
                                        }
                                      >
                                        <option>
                                          ---------Select----------
                                        </option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col> */}
                              </Row>

                              {/* <Row>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="text"
                                        name="electricity_supply"
                                        label="Electricity Supply Status"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.electricity_supply
                                            ? subimttedFormData.electricity_supply
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col>

                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="road_access"
                                        label="Road Access"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData
                                            ? String(
                                                subimttedFormData.road_access
                                              )
                                            : ""
                                        }
                                      >
                                        <option>
                                          ---------Select----------
                                        </option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="textarea"
                                        name="brief_on_generated_wastes"
                                        label="Brief on main generated wastes (solid, liquid), air emissions, noise, and vibrations"
                                        required
                                        disabled={disableFormFields}
                                        rows={6}
                                        value={
                                          subimttedFormData.brief_on_generated_wastes
                                            ? subimttedFormData.brief_on_generated_wastes
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="textarea"
                                        name="brief_on_emissions"
                                        label="Waste management, emissions, and noise control measures and facilities in place."
                                        required
                                        disabled={disableFormFields}
                                        rows={6}
                                        value={
                                          subimttedFormData.brief_on_emissions
                                            ? subimttedFormData.brief_on_emissions
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="text"
                                        name="received_claims"
                                        label="Received claims"
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.received_claims
                                            ? subimttedFormData.received_claims
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col>
                                <Col md={6}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="text"
                                        name="environmental_breach_record"
                                        label="Environmental compliance breach record."
                                        required
                                        disabled={disableFormFields}
                                        value={
                                          subimttedFormData.environmental_breach_record
                                            ? subimttedFormData.environmental_breach_record
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Row>
                                </Col>
                              </Row> */}
                              <br></br>
                              <Row style={{ display: "none" }}>
                                <Col md={12}>
                                  <button
                                    ref={envAuditFormRef}
                                    onClick={() => {
                                      // props.onHide()
                                      // setmodal(false)
                                    }}
                                    type="submit"
                                    style={{ float: "right", fontSize: 18 }}
                                    className="btn btn-primary col-3"
                                    disabled={loading}
                                  >
                                    Next
                                  </button>
                                </Col>
                              </Row>
                            </AvForm>
                          </TabPane>
                          <TabPane tabId={2}>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <CardTitle className="h4">
                                      Document Upload
                                    </CardTitle>

                                    {showDocuments ? (
                                      <ViewFiles
                                        attachments={uploadedImages}
                                        isReturned={isReturned}
                                        reupload={initiateReupload}
                                      />
                                    ) : (
                                      // <ViewFiles data={uploadedImgages} />
                                      <div className="mb-5">
                                        <form
                                          onSubmit={e => {
                                            e.preventDefault()
                                            prepareUploadFiles(e)
                                          }}
                                        >
                                          <Row>
                                            <Col md={12}>
                                              {showeiaAttachments
                                                ? eiaAttachments
                                                : null}
                                              {showOtherEnvAuditAttachments
                                                ? otherEnvAuditAttachments
                                                : null}
                                              {serviceAttachments}
                                            </Col>

                                            <DocumentUpload />
                                          </Row>
                                          {isReturned ? (
                                            <center>
                                              <a
                                                href="#"
                                                onClick={showUploadedFiles}
                                                className="btn btn-warning"
                                              >
                                                Cancel Upload
                                              </a>
                                            </center>
                                          ) : null}
                                          <Row style={{ display: "none" }}>
                                            <Col md={12}>
                                              <button
                                                ref={attachmentsFormRef}
                                                type="submit"
                                              >
                                                Upload Attachments
                                              </button>
                                            </Col>
                                          </Row>
                                        </form>
                                      </div>
                                    )}
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={3}>
                            <div className="row justify-content-center">
                              <Col lg="6">
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                  </div>
                                  <div>
                                    <h5>Proceed to submit Application</h5>
                                  </div>
                                </div>
                              </Col>
                            </div>
                            {editMode ? (
                              <EnvironmentalAuditPreview
                                data={applicationDetails}
                              />
                            ) : null}
                          </TabPane>
                        </TabContent>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              activeTab === 1 ? "previous disabled" : "previous"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                toggleTab(activeTab - 1)
                              }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li
                            className={
                              activeTab === 3 ? "next disabled" : "next"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                if (activeTab === 1) {
                                  envAuditFormRef.current.click()
                                } else if (activeTab === 2) {
                                  if (!disableFormFields) {
                                    if (!cancelUpload) {
                                      attachmentsFormRef.current.click()
                                    } else if (isFreshApplication) {
                                      attachmentsFormRef.current.click()
                                    } else if (!showDocuments) {
                                      attachmentsFormRef.current.click()
                                    } else {
                                      toggleTab(3)
                                    }
                                  }
                                } else {
                                  toggleTab(activeTab + 1)
                                }
                              }}
                            >
                              Next
                            </Link>
                          </li>
                          {activeTab === 3 ? (
                            <li style={{ float: "right" }}>
                              <Link
                                to="#"
                                className="btn btn-primary"
                                onClick={() => {
                                  submitApplication()
                                }}
                                disabled={disableFormFields}
                              >
                                Submit
                              </Link>
                            </li>
                          ) : (
                            ""
                          )}
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row>
              <Card>
                <CardBody>
                  <div className="row justify-content-center">
                    <Col lg="6">
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                          <h5>Application succesfully submitted</h5>
                        </div>
                        <>
                          <Link
                            to="/dashboard"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab(activeTab + 1)
                            }}
                          >
                            Back
                          </Link>
                        </>
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EnvironmentalAuditApply
